import { render, staticRenderFns } from "./Annotations.vue?vue&type=template&id=2f1356bd"
import script from "./Annotations.vue?vue&type=script&lang=js"
export * from "./Annotations.vue?vue&type=script&lang=js"
import style0 from "./Annotations.vue?vue&type=style&index=0&id=2f1356bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports